import debounce from "lodash/debounce";
import { Divider, Tooltip, TooltipBody, TooltipFooter, TooltipHeader, Message, ProgressBar, Currency } from '@wg/wows-react-uikit'
import classNames from 'classnames'
import L from 'leaflet'
import get from 'lodash/get'
import sortBy from 'lodash/sortBy'
import React, { PureComponent } from 'react'
import Highlighter from 'react-highlight-words'
import { Interpolate } from 'react-i18next'
import { Marker, Polygon, FeatureGroup } from 'react-leaflet'
import DevMenu from '../../Containers/DevMenu/DevMenu'
import { t, x } from '../../helpers/localization'
import '../../styles/leaflet.scss'
import { hideRealLayer, showRealLayer } from '../../utils/mapUtils'
import { playClanBaseAmbient, playClanBaseOver, playClanBaseSelect, stopClanBaseAmbient, stopClanBaseOver } from '../../web2ClientAPI/web2ClientAPI'
import TileLayer from '../TileLayer/TileLayer'
import { TileLayer as TileLayerDefault } from 'react-leaflet'
import { UpdatingLayer } from '../UIKit/UIKit'
import BackgroundMap from './BackgroundMap'
import Footer from './Footer'
import MapWrapper from './MapWrapper'
import markers from './markers'
import SideBar, { iScrollC } from './Sidebar'
import styles from './ViewSupply.scss'
import Header from './Header'
import dwhExport from '~/dwhExport'

import { isIngame } from '~/commonmenu'

const SHIP_LAYERS = [
    'vessels',
    'ships'
]

export const subdomains = get(window, ['__PRELOADED_STATE__', 'settings', 'supply', 'tilingServiceSubdomains'], [])

export type ViewSupply_Props = {
    isDevMode: boolean,
    balance: number,
    initialZoom: number,
    zoom: number,
    position: Point,
    initialMaxBounds: PointArray,
    maxBounds: PointArray,
    isMapBlured: boolean,
    buildings: any,
    selectedBuildingId: string | null,
    prevSelectedBuildingId: string | null,
    highlightedBuildingId: string | null,
    highlightTimers: any,
    tooltipTimers: any,
    highlightDelay: number,
    mapHost: string,
    isSidebarOpened: boolean,
    tempHoverBuildingLevel: {
        level: number,
        url: string,
    },
    tempHoverBuildingId: string | null,
    buildingInProgress: string | null,
    isOwnBase: boolean,
    clanId: number,
    confirmBuildingId: string | null,
    hasTooltipConflict: boolean,
    hasBuildPermission: boolean,
    isAchievementsDialogVisible: boolean,
    minZoom: number,
    maxZoom: number,
    backgroundUrl: string | null,
    regularRewards: any,
    battlesStats: any,

    onMapMove: () => {},
    onZoomEnd: () => {},
    onMoveEnd: () => {},
    dropSelection: () => void,
    updateBlur: () => void,
    SetMapRef: (ref: any) => void,
    SetMapRefBg: (ref: any) => void,
    SetSelectedBuilding: (buildingId: string | null) => void,
    SetHighlightedBuilding: (buildingId: string | null) => void,
    OpenSupplySideBar: () => void,
    CloseSupplySideBar: () => void,
    setMapBgRef: (r: any) => void,
    increaseBuildingLevel: (buildingId: string) => () => void,
    setSelectedBuilding: (buildingId: string) => () => void,
    IncreaseBuildingLevel: (buildingId: string) => void,
    SetBuildingLevel: (buildingId: string, level: number) => void,
    SetTempHoverBuildingLevel: (buildingId: string, level: number) => void,
    DropTempHoverBuildingLevel: (buildingId: string) => void,
    setTempHoverLevel: (building: any) => void,
    dropTempHoverLevel: (building: any) => void,
    showBuildingConfirm: (building: any) => void,
    HideBuildingConfirm: () => void,
    selectBuilding: (buildingId: string, needSavePosition?: boolean) => void,
    navigateToTreasury: () => void,
}

export type ViewSupply_State = {
    isZoomingOut: boolean
}

const LAYER_PARAMS = {
    tms: true,
    keepBuffer: 0,
    subdomains: subdomains,
}


type IOpenSidebarButton_Props = {
    isSidebarOpened: boolean,
    CloseSupplySideBar: () => void,
    OpenSupplySideBar: () => void,
    className?: string
}
export class OpenSidebarButton extends PureComponent<IOpenSidebarButton_Props, any> {
    render() {
        const openSidebarButton = classNames(styles.openSidebarButton, {
            [styles.closeSidebarButton]: this.props.isSidebarOpened,
            [this.props.className]: !!this.props.className,
            [styles.openSidebarButtonOffset]: !isIngame()
        })
        return (
            <div
                className={openSidebarButton}
                onClick={this.props.isSidebarOpened ? this.props.CloseSupplySideBar : this.props.OpenSupplySideBar}>
                <div className={this.props.isSidebarOpened ? styles.closeSidebarButtonBuilding : styles.openSidebarButtonBuilding} />
                <div className={this.props.isSidebarOpened ? styles.closeSidebarButtonArrow : styles.openSidebarButtonArrow} />
            </div>
        )
    }
}

export const scrollToBuiding = (buildingId) => {
    const scrollEl = document.getElementById(`sidebar-${buildingId}`)

    setTimeout(() => {
        if (iScrollC) {
            iScrollC.withIScroll((iScroll) => {
                iScroll.scrollToElement(scrollEl, 300, 0, 0)
            })
        }
    }, 300)

}

const getBuildingTooltip = (props: ViewSupply_Props, building: any) => {

    const meta = building.levels[building.level].meta
    const hasNextLevel = building.levels[building.level + 1] !== undefined
    const nextLevelMeta = hasNextLevel ? building.levels[building.level + 1].meta : meta
    const isShipsAndVessels = ['ships', 'vessels'].includes(building.name)
    const isTreasury = building.name === 'treasury'

    const battleType = get(nextLevelMeta, 'levelRequirements.type', undefined)
    const currentBattles = (battleType && props.battlesStats[battleType] !== null) ? props.battlesStats[battleType] : 0
    const needBattles = get(nextLevelMeta, 'levelRequirements.battleCount', 0)
    const battleProgress = Math.min(currentBattles / needBattles, 1)

    return (
        <Tooltip>
            <TooltipHeader isBold={false} isHelpIcon={false}>
                <div className={styles.tooltipInlineHeader}>
                    <div className={styles[`${building.name}Icon`]} />
                    <div className={styles.buildingTooltipHeaderText}>
                        <div className={styles.buildingTooltipModifierTitle}>
                            {`${building.levels[building.level].title}`}
                        </div>
                        <div>
                            <Interpolate
                                i18nKey={x('Улучшений: %(level)s из %(maxLevel)s')}
                                level={building.level}
                                maxLevel={building.maxLevel}
                                parent={'p'}
                                t={t}
                            />
                        </div>
                    </div>
                </div>
            </TooltipHeader>
            <TooltipBody>
                {`${meta.function}`}
            </TooltipBody>

            {meta.bonus ? [
                <Divider key="divider" type="major" />,
                <TooltipBody key="bonus" bgColor="dark">
                    <Highlighter
                        highlightClassName="HighlightPercent"
                        searchWords={window.localSettings.highlighterPercentRegexp}
                        textToHighlight={meta.totalBonus}
                    />
                </TooltipBody>,
            ] : null}

            {isShipsAndVessels ? (
                <React.Fragment>
                    <Divider key="divider" type="major" />
                    <TooltipBody bgColor="dark">
                        <div className={styles.tooltipProgressRow}>
                            {t('Общее количество боев:')}
                            <Interpolate
                                i18nKey={x('%(currentBattles)s/%(needBattles)s')}
                                currentBattles={currentBattles}
                                needBattles={needBattles}
                                t={t}
                            />
                        </div>
                        <ProgressBar
                            size={'small'}
                            completed={battleProgress}
                        />
                    </TooltipBody>
                </React.Fragment>
            ) : null}

            <TooltipFooter mouseIcon="left">{t('Перейти к строению')}</TooltipFooter>
        </Tooltip>
    )
}

export default class ViewSupply extends PureComponent<ViewSupply_Props, ViewSupply_State> {

    state = {
        isZoomingOut: false,
    }

    componentDidMount() {
        if (this.props.isOwnBase && !this.props.isFromSearch){
            debounce(()=>{dwhExport.send('supply.open_page')}, 1000)
        }
        document.addEventListener('keydown', this.onEscape, true)
        playClanBaseAmbient()

        const SearchParams = new URLSearchParams(document.location.search.substr(1))
        const buildingId = SearchParams.get('buildingId')
        if (buildingId) {
            this.props.OpenSupplySideBar()
            this.props.SetSelectedBuilding(buildingId)
            scrollToBuiding(buildingId)
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onEscape, true)
        stopClanBaseAmbient()
        if (window.tooltipProvider) {
            window.tooltipProvider.hide()
        }
    }

    onEscape = (e: SyntheticKeyboardEvent<EventTarget>) => {
        const escKeyCode = 27

        if (e.keyCode === escKeyCode && this.props.selectedBuildingId) {
            e.preventDefault()
            this.props.SetSelectedBuilding(null)
            if (this.props.tempHoverBuildingId) {
                this.props.DropTempHoverBuildingLevel(this.props.tempHoverBuildingId)
            }
        }
    }

    renderBuildings = () => {
        const layersArr = []
        const dataArr = []
        for (const key in this.props.buildings) {
            if (this.props.buildings.hasOwnProperty(key)) {
                dataArr.push(this.props.buildings[key])
            }
        }

        let sortedData = sortBy(dataArr, 'order')

        sortedData.forEach((layer) => {
            const buildingId = layer.name
            const level = layer.level
            const maxLevel = layer.maxLevel
            const levelLayer = layer.levels[level]
            let tileLayerBounds = undefined
            if (levelLayer && levelLayer.geo && levelLayer.geo.edges) {
                const polygon = L.polygon(levelLayer.geo.edges)
                tileLayerBounds = polygon.getBounds()
            }
            if (levelLayer && levelLayer.url) {
                const isSelected = this.props.selectedBuildingId && this.props.selectedBuildingId === buildingId
                let contour = [];
                if (levelLayer.geo && 'contour' in levelLayer.geo) {
                    contour = levelLayer.geo.contour
                } else {
                    console.warn(`There is no contour for: ${buildingId} ${level}`)
                }

                if (level > 0 || this.props.selectedBuildingId === buildingId) {
                    if (isSelected && SHIP_LAYERS.includes(this.props.selectedBuildingId)) {
                        layersArr.push(
                            <TileLayerDefault
                                key={`Layer_${buildingId}_${level} `}
                                url={`${this.props.mapHost}${levelLayer.url}`}
                                className={`blurable tile_${buildingId}`}
                                {...LAYER_PARAMS}
                            />
                        )
                    } else {
                        layersArr.push(
                            <TileLayer
                                key={`Layer_${buildingId}_${level} `}
                                url={`${this.props.mapHost}${levelLayer.url}`}
                                className={`blurable tile_${buildingId}`}
                                {...LAYER_PARAMS}
                                bounds={tileLayerBounds}
                                contour={contour}
                                isSelected={isSelected}
                                id={buildingId}
                                selectBuildingId={this.props.selectedBuildingId}
                            />
                        )
                    }
                }
            } else {
                console.warn(level, levelLayer, layer)
            }


            if (levelLayer && levelLayer.url && levelLayer.geo && levelLayer.geo.contour) {
                const isBlurHighlight = SHIP_LAYERS.includes(layer.type)
                layersArr.push(
                    <Polygon
                        key={`Building_${buildingId}_${level}_${this.props.highlightedBuildingId ? this.props.highlightedBuildingId : 'nohighlight'}`}
                        className={`${isBlurHighlight ? 'buildingGeometryBlured' : 'buildingGeometry'} ${(this.props.highlightedBuildingId === buildingId) ? 'buildingGeometryHighlighted' : ''}`}
                        positions={levelLayer.geo.contour}
                        onmouseover={(e) => {
                            playClanBaseOver()
                            if (window.tooltipProvider && !this.props.selectedBuildingId) {
                                const self_ = this
                                this.props.tooltipTimers[buildingId] = setTimeout(() => {
                                    if (window.tooltipProvider) {
                                        window.tooltipProvider.show(getBuildingTooltip(self_.props, layer))
                                    }
                                }, this.props.highlightDelay)
                            }

                            if (!this.props.selectedBuildingId) {
                                this.props.highlightTimers[buildingId] = setTimeout(() => {
                                    if (!this.props.selectedBuildingId) {
                                        this.props.SetHighlightedBuilding(buildingId)
                                    }
                                }, this.props.highlightDelay)
                            }

                        }}
                        onmouseout={(e) => {
                            stopClanBaseOver()
                            if (window.tooltipProvider) {
                                window.tooltipProvider.hide()
                            }
                            if (!this.props.selectedBuildingId) {
                                clearTimeout(this.props.highlightTimers[buildingId])
                                clearTimeout(this.props.tooltipTimers[buildingId])
                                this.props.SetHighlightedBuilding(null)
                            }

                        }}
                        onmousemove={(e) => {
                            const cursorX = e.originalEvent.pageX - window.scrollX
                            const cursorY = e.originalEvent.pageY - window.scrollY
                            if (window.tooltipProvider && !this.props.selectedBuildingId) {
                                window.tooltipProvider.update({ x: cursorX, y: cursorY })
                            }
                        }}
                        onclick={(e) => {
                            L.DomEvent.stopPropagation(e)
                            playClanBaseSelect()
                            scrollToBuiding(layer.name)
                            this.props.selectBuilding(buildingId, true)
                        }}
                    />
                )
            }

            if (levelLayer && levelLayer.geo && levelLayer.geo.edges && this.props.edgesVisible[buildingId]) {
                const polygon = L.polygon(levelLayer.geo.edges)
                const bounds = polygon.getBounds()

                const positions = [
                    [bounds._northEast.lat, bounds._northEast.lng],
                    [bounds._southWest.lat, bounds._northEast.lng],
                    [bounds._southWest.lat, bounds._southWest.lng],
                    [bounds._northEast.lat, bounds._southWest.lng],
                ]
                layersArr.push(
                    <Polygon
                        key={`edge-${buildingId}`}
                        className={`edgePolygon`}
                        positions={positions}
                    />
                )
            }

            const markerPosition = get(layer, ['levels', layer.level, 'markerPosition'], null)

            if (markerPosition && layer.name !== 'ships' && layer.name !== 'vessels') {
                const isHiddenPin = this.props.selectedBuildingId && this.props.selectedBuildingId !== buildingId
                const isDraggable = this.props.isDevMode

                layersArr.push(
                    <Marker
                        key={`Marker${buildingId}`}
                        icon={markers(buildingId, this.props.zoom, isDraggable)}
                        position={markerPosition}
                        opacity={isHiddenPin ? 0.2 : 1}
                        draggable={isDraggable}
                        ondragend={(e) => {
                            console.log(`${buildingId}`)
                            console.log(`${level}: [${e.target._latlng.lat},${e.target._latlng.lng}]`)
                        }}
                        onmouseover={(e) => {
                            if (!isDraggable) {
                                if (window.tooltipProvider && !this.props.selectedBuildingId) {
                                    this.props.tooltipTimers[buildingId] = setTimeout(() => {
                                        if (window.tooltipProvider) {
                                            window.tooltipProvider.show(getBuildingTooltip(this.props, layer))
                                        }
                                    }, this.props.highlightDelay)
                                }

                                if (!this.props.selectedBuildingId) {
                                    this.props.highlightTimers[buildingId] = setTimeout(() => {
                                        if (!this.props.selectedBuildingId) {
                                            this.props.SetHighlightedBuilding(buildingId)
                                        }
                                    }, this.props.highlightDelay)
                                }
                            }
                        }}
                        onmouseout={(e) => {
                            if (window.tooltipProvider) {
                                window.tooltipProvider.hide()
                            }
                            if (!this.props.selectedBuildingId) {
                                clearTimeout(this.props.highlightTimers[buildingId])
                                clearTimeout(this.props.tooltipTimers[buildingId])
                                this.props.SetHighlightedBuilding(null)
                            }

                        }}
                        onmousemove={(e) => {
                            const cursorX = e.originalEvent.pageX - window.scrollX
                            const cursorY = e.originalEvent.pageY - window.scrollY
                            if (window.tooltipProvider && !this.props.selectedBuildingId) {
                                window.tooltipProvider.update({ x: cursorX, y: cursorY })
                            }
                        }}
                        onclick={(e) => {
                            if (!this.props.selectedBuildingId) {
                                scrollToBuiding(layer.name)
                                this.props.selectBuilding(buildingId, true)
                            }
                        }}
                    />
                )
            }
        })

        return layersArr
    }

    renderPreviewLayer = () => {
        const {
            tempHoverBuildingLevel,
            tempHoverBuildingId,
            confirmBuildingId,
            mapHost,
            buildings,
        } = this.props

        let previewBuilding = null
        let isBuilt = false
        let previewBounds = undefined
        let isConfirmingLevel = false
        let polygon = null
        let bounds = null
        let geo = false
        let level = null

        if (tempHoverBuildingLevel && tempHoverBuildingId) {
            previewBuilding = buildings[tempHoverBuildingId]
            geo = get(previewBuilding, ['levels', `${tempHoverBuildingLevel.level}`, 'geo', 'contour'], false)

            if (geo) {
                polygon = L.polygon(geo)
                bounds = polygon.getBounds()
                previewBounds = bounds

                hideRealLayer(tempHoverBuildingId)

                isBuilt = parseInt(tempHoverBuildingLevel.level) <= previewBuilding.level
                isConfirmingLevel = (
                    confirmBuildingId &&
                    (previewBuilding.name === confirmBuildingId) &&
                    (parseInt(tempHoverBuildingLevel.level) === (previewBuilding.level + 1))
                )

                return (
                    <UpdatingLayer
                        key={`Preview_${(isBuilt || isConfirmingLevel) ? 'Color' : 'NoColor'}`}
                        url={`${mapHost}${tempHoverBuildingLevel.url}`}
                        className={(isBuilt || isConfirmingLevel) ? styles.previewLayer : styles.previewLayerFuture}
                        bounds={previewBounds}
                        {...LAYER_PARAMS}
                        contour={geo}
                        hasDifferentLayers={tempHoverBuildingId === 'ships' || tempHoverBuildingId === 'vessels'}
                    />
                )
            }

        }

        if (confirmBuildingId) {
            previewBuilding = buildings[confirmBuildingId]
            level = ((previewBuilding.level + 1) <= previewBuilding.maxLevel)
                ? previewBuilding.level + 1
                : previewBuilding.maxLevel

            geo = get(previewBuilding, ['levels', `${level}`, 'geo', 'contour'], false)

            if (geo) {
                polygon = L.polygon(geo)
                bounds = polygon.getBounds()
                previewBounds = bounds

                hideRealLayer(tempHoverBuildingId)

                return (
                    <TileLayer
                        key={`Preview_${isBuilt ? 'Color' : ''}`}
                        className={styles.previewLayer}
                        url={`${mapHost}${previewBuilding.levels[level].url}`}
                        bounds={previewBounds}
                        {...LAYER_PARAMS}
                        contour={geo}
                        isSelected={true}
                    />
                )
            }
        }

        showRealLayer()

        return null
    }

    renderDevPanel = () => {
        return (
            <ul className={styles.devPanel}>
                {items}
            </ul>
        )
    }

    render() {
        let title = ''
        let name = ''
        let bonus = ''
        let buildingData = this.props.prevSelectedBuildingId ? { ...this.props.buildings[this.props.prevSelectedBuildingId] } : null

        if (buildingData) {
            if (this.props.confirmBuildingId) {
                buildingData.level = parseInt(buildingData.level) + 1
            }

            if (this.props.tempHoverBuildingLevel) {
                buildingData.level = this.props.tempHoverBuildingLevel.level
            }

            title = get(buildingData, ['levels', `${buildingData.level}`, 'title'])
            name = get(buildingData, 'name', '')
            if (buildingData.level === 0) {
                bonus = get(buildingData, ['levels', '0', 'meta', 'function'])
            } else {
                bonus = get(buildingData, ['levels', `${buildingData.level}`, 'meta', 'totalBonus'])
            }
        }

        return (
            <div className={styles.container}>
                <div className={styles.filter}>
                    <svg height="0" width="0">
                        <defs>
                            <filter id="blur-filter" x="-20%" y="-20%" width="140%" height="140%">
                                <feGaussianBlur in="SourceGraphic" stdDeviation="15" />
                            </filter>
                            <linearGradient id="linear-gradient" x2="0" y2="1">
                                <stop offset="0%" stopColor="rgba(0, 255, 255, 0)" />
                                <stop offset="50%" stopColor="rgba(0, 255, 240, 0.16)" />
                                <stop offset="100%" stopColor="rgba(15, 25, 34, 0.2)" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
                <BackgroundMap
                    mapHost={this.props.mapHost}
                    isVisible={(this.props.selectedBuildingId || this.state.isZoomingOut) ? false : true}
                    maxBounds={this.props.maxBounds}
                    SetMapRefBg={(r) => {
                        if (r) {
                            this.props.SetMapRefBg(r)
                        }
                    }}
                />
                <MapWrapper
                    isSidebarOpened={this.props.isSidebarOpened}
                    minZoom={this.props.minZoom}
                    maxZoom={this.props.maxZoom}
                    position={this.props.position}
                    initialZoom={this.props.initialZoom}
                    maxBounds={this.props.maxBounds}
                    onMapMove={this.props.onMapMove}
                    onMoveEnd={this.props.onMoveEnd}
                    onZoomStart={(e) => {
                        this.setState({ isZoomingOut: true })
                    }}
                    onZoomEnd={(e) => {
                        this.setState({ isZoomingOut: false })
                        this.props.onZoomEnd(e)
                    }}
                    SetMapRef={(r) => {
                        if (r) {
                            this.props.SetMapRef(r)
                        }
                    }}
                    onClick={() => {
                        if (this.props.selectedBuildingId) {
                            this.props.dropSelection()
                        }
                    }}
                >
                    {this.props.backgroundUrl ? (
                        <TileLayer
                            url={this.props.backgroundUrl}
                            className={'blurable'}

                            {...LAYER_PARAMS}
                        />
                    ) : null}
                    {this.props.buildings ? this.renderBuildings() : null}
                    {this.renderPreviewLayer()}
                </MapWrapper>
                <OpenSidebarButton
                    isSidebarOpened={this.props.isSidebarOpened}
                    CloseSupplySideBar={this.props.CloseSupplySideBar}
                    OpenSupplySideBar={this.props.OpenSupplySideBar}
                />
                <div className={styles.innerShadow} />

                <Header
                    title={title}
                    selectedBuildingId={this.props.selectedBuildingId}
                    dropSelection={this.props.dropSelection}
                    maxLevel={buildingData ? buildingData.maxLevel : 0}
                    level={buildingData ? buildingData.level : 0}
                    name={name}
                />

                <Footer
                    isOwnBase={this.props.isOwnBase}
                    tempHoverBuildingId={this.props.tempHoverBuildingId}
                    selectedBuildingId={this.props.selectedBuildingId}
                    confirmBuildingId={this.props.confirmBuildingId}
                    dropSelection={this.props.dropSelection}
                    bonus={bonus}
                    level={buildingData ? buildingData.level : null}
                    navigateToTreasury={this.props.navigateToTreasury}
                />
                {this.props.buildings ? (
                    <SideBar
                        isSidebarOpened={this.props.isSidebarOpened}
                        buildings={this.props.buildings}
                        selectedBuildingId={this.props.selectedBuildingId}
                        confirmBuildingId={this.props.confirmBuildingId}
                        SetSelectedBuilding={this.props.SetSelectedBuilding}
                        balance={this.props.balance}
                        accumulativeResource={this.props.accumulativeResource}
                        showBuildingConfirm={this.props.showBuildingConfirm}
                        setTempHoverLevel={this.props.setTempHoverLevel}
                        dropTempHoverLevel={this.props.dropTempHoverLevel}
                        regularRewards={this.props.regularRewards}
                        battlesStats={this.props.battlesStats}

                        mapHost={this.props.mapHost}
                        buildingInProgress={this.props.buildingInProgress}
                        isOwnBase={this.props.isOwnBase}
                        hasBuildPermission={this.props.hasBuildPermission}
                        increaseBuildingLevel={this.props.increaseBuildingLevel}
                        HideBuildingConfirm={this.props.HideBuildingConfirm}
                        navigateToTreasury={this.props.navigateToTreasury}
                    />
                ) : null}

                {this.props.isDevMode ? (
                    <DevMenu />
                ) : null}
            </div>
        )
    }
}
